import {
  Module,
  VuexModule,
  Mutation,
  Action,
} from 'vuex-module-decorators';

import {
  BASE_URL,
  BASE_URL_OLD,
  NEW_WINLOSE_REPORT,
  NEW_WINLOSE_REPORT_TOGGLE,
  WINLOSE_REPORT_V2,
  WINLOSE_REPORT_LOGS,
  WINLOSE_RESULT,
  ALL_WINLOSE_REPORT,
  GET_RESULT_ALL_DS,
  GET_RESULT_AMBPOKER,
  PROVIDER_REPORT,
  PROVIDER_TYPE_REPORT,
  AMBSLOT_RESULT_MH,
  GENERATE_EXCEL_INVOICE,
  INVOICE_REPORT,
  GENERATE_PDF_INVOICE,
  M_POST,
  EVO_RESULT,
  WINLOSE_RANGE_DATE_REPORT_LOGS,
  FETCH_RESULT_AMBSLOT_ARCADE,
  WINLOSE_REPORT_NEW_V2,
  WINLOSE_DOWNLOAD_REPORT_CSV,
} from '@/utils/api';

import { ICriteria, FetchType } from '@/interface/Report';

import Vue from 'vue';

@Module({name: 'report'})
export default class Report extends VuexModule {
  dataWinLose: any = {};

  dataWinLoseLog: any = {};

  dataInvoice: any = {};

  dataFile: any = {};

  dataCSV: Blob | null = null;

  defaultDataWinlose: any = {
    users: [],
    pageAmount: 1,
    startCount: 1,
    footerSummary: {
      footer: [
        { amount: 0, marketing: 0, total: 0 },
        { amount: 0, marketing: 0, total: 0 },
        { amount: 0, marketing: 0, total: 0 },
      ],
      turnover: 0,
      marketing: 0,
      raw: {
        winlose: 0,
      },
    },
  };

  @Mutation
  mutateWinLose(dataWinLose: any) {
    if (dataWinLose.message) this.dataWinLose = this.defaultDataWinlose;
    else this.dataWinLose = dataWinLose;
  }

  @Action({commit: 'mutateWinLose'})
  FetchWinLose(criteria: ICriteria) {
    let path = WINLOSE_REPORT_V2;
    if (criteria.fetchType === FetchType.new) path = NEW_WINLOSE_REPORT;
    if (criteria.fetchType === FetchType.all) path = ALL_WINLOSE_REPORT;
    return Vue.axios({
      url: BASE_URL + path,
      data: criteria,
      method: M_POST,
    })
      .then(({data}) => {
        const { code } = data.status;
        if (code === 0) {
          const dataWinLose = data.data;
          return {
            ...dataWinLose,
          };
        } else {
          throw data.status;
        }
      })
      .catch((err) => err);
  }

  @Action({ commit: 'mutateWinLose' })
  FetchNewWinLoseV2(criteria: object) {
    return Vue.axios({
      url: BASE_URL + WINLOSE_REPORT_NEW_V2,
      data: criteria,
      method: M_POST,
    })
      .then(({ data }) => {
        const { code } = data.status;
        if (code === 0) {
          const dataWinLose = data.data;
          return {
            ...dataWinLose,
          };
        } else {
          throw data.status;
        }
      })
      .catch((err) => err);
  }

  @Action({commit: 'mutateWinLose'})
  FetchWinLoseByToggle(criteria: ICriteria) {
    return Vue.axios({
      url: BASE_URL + NEW_WINLOSE_REPORT_TOGGLE,
      data: criteria,
      method: M_POST,
    })
      .then(({data}) => {
        const { code } = data.status;
        if (code === 0) {
          const dataWinLose = data.data;
          return {
            ...dataWinLose,
          };
        } else {
          throw data.status;
        }
      })
      .catch((err) => err);
  }

  @Mutation
  mutateWinLoseLog(dataWinLoseLog: any) {
    this.dataWinLoseLog = dataWinLoseLog;
  }

  @Action({commit: 'mutateWinLoseLog'})
  FetchWinLoseLog(criteria: object) {
    return Vue.axios({
      url: BASE_URL + WINLOSE_REPORT_LOGS,
      data: criteria,
      method: M_POST,
    })
      .then(({data}) => {
        const {code} = data.status;
        if (code === 0) {
          const dataWinLoseLog = data.data;
          return {
            ...dataWinLoseLog,
          };
        } else {
          throw data.status;
        }
      })
      .catch((err) => err);
  }

  @Action({commit: 'mutateWinLoseLog'})
  FetchWinLoseRangeLog(criteria: object) {
    return Vue.axios({
      url: BASE_URL + WINLOSE_RANGE_DATE_REPORT_LOGS,
      data: criteria,
      method: M_POST,
    })
      .then(({data}) => {
        const {code} = data.status;
        if (code === 0) {
          const dataWinLoseRangeLog = data.data;
          return {
            ...dataWinLoseRangeLog,
          };
        } else {
          throw data.status;
        }
      })
      .catch((err) => err);
  }

  @Action
  FetchResult(params) {
    let url = '';
    switch (params.products) {
      case 'DS':
        url = GET_RESULT_ALL_DS;
        break;
      case 'AMBPOKER':
        url = GET_RESULT_AMBPOKER;
        break;
      case 'EVOPLAY':
        url = EVO_RESULT;
        break;
      default:
        url = WINLOSE_RESULT;
        break;
    }
    return Vue.axios({
      url: ['AMBSLOT', 'EVOPLAY'].includes(params.products) ? url : BASE_URL_OLD + url,
      data: params,
      method: M_POST,
    })
      .then(({data}) => {
        const {code} = data.status;
        if (code === 0) {
          const result = data;
          return result;
        } else {
          throw code;
        }
      })
      .catch((err) => err);
  }

  @Action
  FetchResultMH(params) {
    return Vue.axios({
      url: AMBSLOT_RESULT_MH,
      method: M_POST,
      data: params,
      headers: {
        Authorization: '',
      },
    })
      .then(({data}) => {
        const {code} = data.status;
        if (code === 0) {
          return data.data;
        } else {
          throw data.status;
        }
      })
      .catch((err) => err);
  }

  @Action
  FetchResultBackend(params) {
    return Vue.axios({
      url: BASE_URL + FETCH_RESULT_AMBSLOT_ARCADE,
      method: M_POST,
      data: params,
    })
      .then(({data}) => {
        const {code} = data.status;
        if (code === 0) {
          return data.data;
        } else {
          throw data.status;
        }
      })
      .catch((err) => err);
  }

  @Action
  FetchProviderReport(criteria: object) {
    return Vue.axios({
      url: BASE_URL + PROVIDER_REPORT,
      data: criteria,
      method: M_POST,
    })
      .then(({data}) => {
        const {code} = data.status;
        if (code === 0) {
          return data.data;
        } else {
          throw data.status;
        }
      })
      .catch((err) => err);
  }

  @Action
  FetchProviderReportByType(criteria: object) {
    return Vue.axios({
      url: BASE_URL + PROVIDER_TYPE_REPORT,
      data: criteria,
      method: M_POST,
    })
      .then(({data}) => {
        const {code} = data.status;
        if (code === 0) {
          return data.data;
        } else {
          throw data.status;
        }
      })
      .catch((err) => err);
  }

  @Mutation
  mutateInvoice(data: any) {
    this.dataInvoice = data;
  }

  @Action({commit: 'mutateInvoice'})
  FetchInvoice(criteria: object) {
    return Vue.axios({
      url: BASE_URL + INVOICE_REPORT,
      data: criteria,
      method: M_POST,
    })
      .then(({data}) => {
        const {code} = data.status;
        if (code === 0) {
          const dataInvoice = data.data;
          return {
            ...dataInvoice,
          };
        } else {
          throw data.status;
        }
      })
      .catch((err) => err);
  }

  @Mutation
  mutateFileExcel(data: any) {
    this.dataFile = data;
  }

  @Action({commit: 'mutateFileExcel'})
  generateFileExcel(dataInvoice: object) {
    return Vue.axios({
      url: BASE_URL + GENERATE_EXCEL_INVOICE,
      responseType: 'blob',
      data: dataInvoice,
      method: M_POST,
    })
      .then(({data}) => {
        const dataFile = data;
        return {
          dataFile,
        };
      })
      .catch((err) => err);
  }

  @Mutation
  mutateFilePdf(data: any) {
    this.dataFile = data;
  }

  @Action({commit: 'mutateFilePdf'})
  generateFilePdf(dataInvoice: object) {
    return Vue.axios({
      url: BASE_URL + GENERATE_PDF_INVOICE,
      responseType: 'blob',
      data: dataInvoice,
      method: M_POST,
    })
      .then(({data}) => {
        const dataFile = data;
        return {
          dataFile,
        };
      })
      .catch((err) => err);
  }

  @Mutation
  mutateCSVReport(data: Blob) {
    this.dataCSV = data;
  }

  @Action
  async FetchCSVReport(params: any) {
    return Vue.axios({
      url: BASE_URL + WINLOSE_DOWNLOAD_REPORT_CSV,
      method: M_POST,
      responseType: 'blob',
      params: { rate: params.rate },
      data: JSON.stringify(params.criteria),
      headers: {
        'Content-Type': 'application/json', // Explicitly set the content type to JSON
      },
    })
      .then(({ data }) => data)
      .catch((err) => {
        throw err;
      });
  }
}
